const store = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
    },
    mutations: {
    }
}

export default store
